import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Button2.css';
import './DefinitionPage2.css';
import {
  BarChart,
  Users,
  UserCheck,
  MapPin,
  BookOpenCheck
} from 'lucide-react';

const CustomButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isHovered, setIsHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="button2-container">
        <div
          className={`custom-card-button state ${isActive('/state-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/state-view')}
        >
          <MapPin className="icon" />
          <span>Project Achievement View</span>
        </div>

        <div
          className={`custom-card-button ${isActive('/summary') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/summary')}
        >
          <BarChart className="icon" />
          <span>View Employee Summary</span>
        </div>

        <div
          className={`attractive-card-button ${isHovered ? 'hover' : ''} ${isActive('/all-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/all-view')}
        >
          <UserCheck className="icon" />
          <span>View Individual Performance</span>
        </div>

        <div
          className={`custom-card-button alt ${isActive('/team-view') ? 'active' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => navigate('/team-view')}
        >
          <Users className="icon" />
          <span>Team View</span>
        </div>

        <div
          className={`custom-card-button definition-button`}
          onClick={() => setShowModal(true)}
        >
          <BookOpenCheck className="icon" />
          <span>Definition</span>
        </div>
      </div>

      {showModal && (
        <div className="definition-overlay">
          <div className="definition-box">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
            <h2>Key Definitions - View Individual Performance</h2>
            <p className="definition-note">
              <strong>Note:</strong> The "Last data updated" date and time on the dashboard shows when the data was last refreshed. All information is based on data available up to that point.
            </p>

            <table className="definition-table">
              <tbody>
                <tr><th>PID</th><td>Choose the project ID you want to view data for.</td></tr>
                <tr><th>Date Range</th><td>Select start and end dates to filter data.</td></tr>
                <tr><th>Organization Name</th><td>Choose the Organization (State) linked to the PID.</td></tr>
                <tr><th>Manager Name</th><td>Select the manager to filter data accordingly.</td></tr>
                <tr><th>Total Applications in Open_DI</th><td>Open schemes as of yesterday or within selected date range.</td></tr>
                <tr><th>Total Applications in DS_DI</th><td>Document Submitted status for DI.</td></tr>
                <tr><th>Total Applications in BR_DI</th><td>Benefit Received status for DI.</td></tr>
                <tr><th>Total Applications in Open_DFL</th><td>DFL cases opened as of yesterday or within selected range.</td></tr>
                <tr><th>Total Applications in DS_DFL</th><td>Document Submitted status for DFL.</td></tr>
                <tr><th>Total Applications in BR_DFL</th><td>Benefit Received status for DFL.</td></tr>
                <tr><th>Total Applications in Open_YC</th><td>Yojana Cards opened as of yesterday or within selected range.</td></tr>
                <tr><th>Total Applications in DS_YC</th><td>Document Submitted status for YC.</td></tr>
                <tr><th>Total Applications in BR_YC</th><td>Benefit Received status for YC.</td></tr>
                <tr><th>Work done in total projects</th><td>Total unique projects with applications.</td></tr>
                <tr><th>Work done in total Organization</th><td>Total unique Organizations with applications.</td></tr>
                <tr><th>Monthly work Done</th><td>Monthly count of DI, DFL, YC applications (Open, DS, BR).</td></tr>
                <tr><th>Weekly Applications Data</th><td>Weekly count of DI, DFL, YC applications (Open, DS, BR).</td></tr>
                <tr><th>Project Org wise data</th><td>Application counts grouped by Project and Organization.</td></tr>
                <tr><th>Service Type</th><td>Pie chart showing service-wise application counts.</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomButton;
